'use client';

import { useCallback, useContext } from 'react';
import { copyTextToClipboard as _copyTextToClipboard } from '../_utils/windowDocument';
import { LayoutContext } from '@/_contexts/LayoutProvider';

export const useCopy = () => {
  const { setTextToCopy } = useContext(LayoutContext);

  const fallbackCopy = useCallback(
    (text: string) => {
      setTextToCopy(text);
    },
    [setTextToCopy],
  );

  const copyTextToClipboard = useCallback(
    async (text: string) => {
      await _copyTextToClipboard(text, fallbackCopy);
    },
    [fallbackCopy],
  );

  return {
    copyTextToClipboard,
  };
};
